import { BasicRequest } from "./basicRequest";

export class DeleteValidationDefinitionRequest extends BasicRequest{
    public validationDefinitionId! : number;
    public physicalDelete : boolean = false;
}